/**
 * Colour uniforms as `vec3` (linear working-space RGB from a `#rrggbb` hex), which the TSL typings combine with the
 * other vector nodes. `setLinearRgb` writes a hex into an existing vector without allocating.
 */
import { Color, Vector3 } from 'three/webgpu'

const scratch = new Color()

/** Writes the linear RGB of `hex` into `out` and returns it. Allocation-free. */
export function setLinearRgb(out: Vector3, hex: string): Vector3 {
  scratch.set(hex)
  return out.set(scratch.r, scratch.g, scratch.b)
}

/** A new vector holding the linear RGB of `hex` (build time only). */
export function linearRgb(hex: string): Vector3 {
  return setLinearRgb(new Vector3(), hex)
}
